<template>
  <div class="bg-pattern-gray">
    <div class="float-start mb-3">
      <button
        class="btn btn-success btn-big _3d-input"
        @click="handleBack"
      >
        Back
      </button>
    </div>
    <div class="float-end mb-3 d-flex align-items-center gap-2">
      <el-dropdown v-if="quotation_data && quotation_data.quotation_type" @command="handleCommandDropdown">
        <span class="el-dropdown-link" style="cursor: pointer; padding: 10px; border: 1px solid rgb(221, 221, 221); border-radius: 4px; background: white;">
          <i class="fas fa-ellipsis-v"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- DRAFT only: Save, Edit, Delete -->
            <!-- <el-dropdown-item v-if="isDraft" command="save"><i class="fa fa-save"></i> Save</el-dropdown-item> -->
            <el-dropdown-item v-if="isDraft" command="edit"><i class="fa fa-edit"></i> Edit</el-dropdown-item>
            <el-dropdown-item v-if="isDraft" command="delete"><i class="fa fa-trash"></i> Delete</el-dropdown-item>
            <!-- SENT only: Void -->
            <el-dropdown-item v-if="isSent" command="void"><i class="fa fa-ban"></i> Void</el-dropdown-item>
            <!-- Always: Make Copy, Download, Print, Convert to Invoice -->
            <el-dropdown-item command="copy"><i class="fa fa-copy"></i> Make Copy</el-dropdown-item>
            <!-- <el-dropdown-item command="download"><i class="fa fa-download"></i> Download</el-dropdown-item> -->
            <!-- <el-dropdown-item command="print"><i class="fa fa-print"></i> Print</el-dropdown-item> -->
            <el-dropdown-item command="convert"><i class="fa fa-exchange-alt"></i> Convert to Invoice</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <button class="btn btn-success btn-big _3d-input me-2" @click="sendEmail">
        Email Quotation
      </button>
    </div>

    <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="1200px" frameborder="0"></iframe>
    <div v-else class="alert alert-warning my-3" role="alert">
      The PDF preview is not available yet for this quotation.
      <button class="btn btn-link p-0 align-baseline" @click="getQuotationByNumber">Reload</button>
    </div>

    <div class="d-flex justify-content-end mb-3 align-items-center">
      <button class="btn btn-success btn-big _3d-input me-2" @click="sendEmail">
        Email Quotation
      </button>

      <el-dropdown v-if="quotation_data && quotation_data.quotation_type" @command="handleCommandDropdown">
        <span class="el-dropdown-link" style="cursor: pointer; padding: 8px 12px; border: 1px solid #ddd; border-radius: 4px; background: white; display: inline-block;">
          <i class="fas fa-ellipsis-v"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- DRAFT only: Save, Edit, Delete -->
            <el-dropdown-item v-if="isDraft" command="save"><i class="fa fa-save"></i> Save</el-dropdown-item>
            <el-dropdown-item v-if="isDraft" command="edit"><i class="fa fa-edit"></i> Edit</el-dropdown-item>
            <el-dropdown-item v-if="isDraft" command="delete"><i class="fa fa-trash"></i> Delete</el-dropdown-item>
            <!-- SENT only: Void -->
            <el-dropdown-item v-if="isSent" command="void"><i class="fa fa-ban"></i> Void</el-dropdown-item>
            <!-- Always: Make Copy, Download, Print, Convert to Invoice -->
            <el-dropdown-item command="copy"><i class="fa fa-copy"></i> Make Copy</el-dropdown-item>
            <el-dropdown-item command="download"><i class="fa fa-download"></i> Download</el-dropdown-item>
            <el-dropdown-item command="print"><i class="fa fa-print"></i> Print</el-dropdown-item>
            <el-dropdown-item command="convert"><i class="fa fa-exchange-alt"></i> Convert to Invoice</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { ElMessageBox } from 'element-plus';
import { resolveApiAssetUrl } from '../../config/url';

export default {
  name: "ShowQuotationPdf",
  props: {
    title: String,
  },
  data() {
    return {
      pdfUrl: "",
      quotation_data: {},
      quotation_number: "",
      cameFromCreate: false,
    };
  },
  created() {
    this.cameFromCreate = this.$route.query.from === 'create';
    // Clean up the query param so it doesn't persist in URL
    if (this.cameFromCreate) {
      this.$router.replace({
        ...this.$route,
        query: { ...this.$route.query, from: undefined },
      });
    }
    this.initQuotation();
  },
  computed: {
    pageTitle() {
      return (document.title = `${this.title.replace(/\b\w/g, (match) =>
        match.toUpperCase()
      )} | Smoothbalance`);
    },
    isDraft() {
      return this.quotation_data && this.quotation_data.quotation_type === 'draft';
    },
    isSent() {
      return this.quotation_data && this.quotation_data.quotation_type === 'sent';
    },
    isVoid() {
      return this.quotation_data && this.quotation_data.quotation_type === 'void';
    },
  },
  methods: {
    handleBack() {
      if (this.isDraft) {
        ElMessageBox.alert(
          'The quotation has been saved as a draft.',
          'Quotation Saved',
          {
            confirmButtonText: 'OK',
            type: 'success',
          }
        ).then(() => {
          this.$router.push({ name: 'edit-quotation', params: { id: this.quotation_number } });
        });
      } else {
        this.$router.push({ name: 'edit-quotation', params: { id: this.quotation_number } });
      }
    },
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    /**
     * Initialize quotation_number from either route params or localStorage
     */
    initQuotation() {
      // Try route param first
      const routeId = this.$route.params.id;
      this.quotation_number = routeId;

      // Now fetch quotation details from store
      this.getQuotationByNumber();
    },

    getQuotationByNumber() {
      if (!this.quotation_number) return;

      this.showLoading();
      this.$store
        .dispatch("quotation/getQuotationByNumber", {
          quotation_number: this.quotation_number,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.quotation_data = res.data.response;
            this.pdfUrl = resolveApiAssetUrl(this.quotation_data.pdfLink);
            // normalize to always use the same property
            this.quotation_number = res.data.quotationNumber || res.data.quotation_number;
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    sendEmail() {
      if (!this.quotation_data?.quotation_number) return;

      this.$store
        .dispatch("quotation/sendEmail", {
          quotation_number: this.quotation_data.quotation_number,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.$toast.success("Email sent successfully");
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        });
    },
    handleCommandDropdown(command) {
      if (command === 'save') {
        this.$toast.info("Save functionality will be implemented soon.");
      } else if (command === 'edit') {
        this.$router.push({ name: 'edit-quotation', params: { id: this.quotation_number } });
      } else if (command === 'delete') {
        this.$toast.info("Delete functionality will be implemented soon.");
      } else if (command === 'void') {
        this.$toast.info("Void functionality will be implemented soon.");
      } else if (command === 'copy') {
        const qNumber = this.quotation_number || this.$route.params.id;
        if (!qNumber) {
          this.$toast.error("Quotation number not available.");
          return;
        }
        this.$router.push(`/copy-quotation/${qNumber}`);
      } else if (command === 'download') {
        if (this.pdfUrl) {
          window.open(this.pdfUrl, '_blank');
        } else {
          this.$toast.error("PDF is not available for download.");
        }
      } else if (command === 'print') {
        const iframe = document.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.print();
        } else {
          this.$toast.error("Unable to print PDF preview.");
        }
      } else if (command === 'convert') {
        const qNumber = this.quotation_number || this.$route.params.id;
        if (!qNumber) {
          this.$toast.error("Quotation number not available.");
          return;
        }
        this.$router.push(`/convert-quotation/${qNumber}`);
      }
    },
  },
};
</script>
